import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";
import { format, parseISO } from "date-fns";

import Modal from "../../../reusable/reactModal";
import { InvoiceModalPropTypes } from "../lib/types";
import {
  StyledModalBody,
  StyledModalContents,
  StyledModalText,
  StyledModalSubHeader,
} from "../lib/styles";
import { redesignTheme } from "../../../theme/theme";

const StyledDescription = styled(StyledModalText)`
  margin-bottom: ${redesignTheme.spacing[4.5]};
`;

const InvoiceModal = ({
  closeModal,
  modal,
  paymentDueOn,
  refillAmount,
  refillThreshold,
  type,
}: InvoiceModalPropTypes): React.ReactElement => {
  const renewalDate =
    paymentDueOn && paymentDueOn !== "--" && paymentDueOn !== "N/A"
      ? format(parseISO(paymentDueOn), "MMM dd, yyyy")
      : "";

  return (
    <Modal
      ariaLabel={i18n.translate(
        "admin_pages.settings.billing.invoice_modal_aria_label"
      )}
      close={closeModal}
      showDialog={modal === "invoices"}
      testId="invoice-modal"
      title="Payment by invoice"
    >
      <StyledModalBody>
        <StyledModalContents>
          <StyledDescription>
            {i18n.translate(
              "admin_pages.settings.billing.invoice_modal.invoice_modal_description"
            )}
          </StyledDescription>

          {(type === "both" || type === "subscription") && (
            <>
              <StyledModalSubHeader>
                {i18n.translate("title.subscription_billing")}
              </StyledModalSubHeader>
              <StyledDescription>
                {i18n.translate(
                  "admin_pages.settings.billing.invoice_modal.subscription_description",
                  { renewalDate }
                )}
              </StyledDescription>
            </>
          )}
          {(type === "both" || type === "reward") && (
            <>
              <StyledModalSubHeader>
                {i18n.translate("title.reward_billing")}
              </StyledModalSubHeader>
              <StyledDescription>
                {i18n.translate(
                  "admin_pages.settings.billing.invoice_modal.rewards_description",
                  { refillThreshold, refillAmount }
                )}
              </StyledDescription>
            </>
          )}
        </StyledModalContents>
      </StyledModalBody>
    </Modal>
  );
};

export default InvoiceModal;
